export default "__VITE_ASSET__DJqJvn45__"